//action
export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';

export const setCurrentService = selected => ({
  type: SET_CURRENT_SERVICE,
  selected,
});

//reducer
const initialState = {
  currentService: [],
};

const reducer = (state = initialState, action) => {
  switch(action.type) {
    case SET_CURRENT_SERVICE:
      return {
        ...state,
        currentService: [ action.selected ],
      };
    default:
      return state;
  }
};

export default reducer;
